import React from 'react'
import { Images } from '../../constants'
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';
const Banner = () => {

  return (
    <Carousel className='select-none '  transitionTime={500} autoPlay infiniteLoop interval={8000} showThumbs={false}  showStatus={false}>
                <div>
                    <img alt="banner" className='scale-200' src={Images.BANNER1} />
                   
                </div>
                <div>
                    <img alt="banner"  src={Images.BANNER2} />
                    
                </div>
                <div>
                    <img alt="banner"  src={Images.BANNER3} />
                    
                </div>
            </Carousel>
  )
}

export default Banner